import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { RequestViewQuery } from './RequestViewQuery.graphql.ts';

export function preloadRequestViewQuery(id: string) {
	/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
	return query({ query: RequestViewQuery, variables: { id } });
}
